import React from 'react'
import "./Page4.css"

const Page4 = () => {
  return (
    <div className='p-main'>
        <div className='p'>
      <div className='p-heading'>
        <h2>ENHANCING EVERYONE TO BE SUCCESSFUL !</h2>
        <p>AT REDPHANTOM TECH NOVELTY, WE BELIEVE THAT ENABLING EVERYONE TO EMERGE IS 
        <br /> TO BECOME A BETTER VERSION OF THEMESELVES EVERY DAY.</p>
      </div>
      </div>
      <div className="p-main1">
        <div className='p-main21'>
             <div className="p-main211">
              <h3>Empowered To Learn</h3>
              <p>We take greate pleaeure in referring to overselves as a busineess that is always asking question and continually learning new rhings.With greate and development relationships, there will never be a day when your kills and knowledge do not continue to improve</p>
             </div>
             <div className="p-main211">
                <h3>Empowered To Innovate</h3>
                <p>We only believe in two types of ideas: those that are 
currently excellent and effective, and those that will
become better and more effective in the near future. It is possible for RPTN's to fail at innovation once, but they will never, ever fail at innovation again.</p>
             </div>
        </div>
        <div className='p-main21'>
             <div className="p-main211">
              <h3>Empowered To Lead</h3>
              <p>Statrting on your first day at RPTN, you may prepare yourself to take on a variety of positions in sales, delivery, strategy and other area. You can even prapare yourself to take on the job of team leader, country leader or whole function leader.</p>
             </div>
             <div className="p-main211">
                <h3>Empowered To Grow</h3>
                <p>Entrepreneurial, creative, and open to change companies require individuals with these characteristics, creative and open to change. Providing you with enough changes to think, attempt and fail until you achieve in one approach to satisfy you need for knowledge.</p>
             </div>
        </div>
      </div>
    </div>
  )
}

export default Page4
